// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2wB_q","form":"styles_form__3FF4K"};